module.exports = __webpack_public_path__ + "static/img/ldt6.e410d40.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/ldt6.png
// module id = 85p0
// module chunks = 0